export default __webpack_public_path__ + "static/home-bg-53b9768d3d665ca1f27244ce6357d752.jpg";